import { createFileRoute } from '@tanstack/react-router'
import { ManageAccessPage } from 'pages/manageAccess/ManageAccessPage'
import React from 'react'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import {
  accessSearchParams,
  SEARCH_PARAM_ACCESS_SCOPE,
} from 'routes/access/-searchParams'

const RouteComponent = () => {
  const search = Route.useSearch()

  return (
    <ManageAccessPage
      orgId={search[SEARCH_PARAM_ORG_ID]}
      siteId={search[SEARCH_PARAM_SITE_ID]}
      accessScope={search[SEARCH_PARAM_ACCESS_SCOPE]}
    />
  )
}

export const Route = createFileRoute('/access/')({
  component: RouteComponent,
  validateSearch: accessSearchParams,
  staticData: {
    title: 'Manage Access',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
    },
  },
})
